import { companyInfo } from '@/mocks/company';

export default function FinalCTASection() {
  const whatsappMessage = encodeURIComponent('Olá! Estou no site da Maquinasdesoldageomembrana.com.br e gostaria de informações sobre máquinas de solda de geomembrana.');
const whatsappUrl = `https://wa.me/${companyInfo.whatsapp}?text=${whatsappMessage}`;

  return (
    <section className="py-16 md:py-24 bg-foreground-950 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-1/4 w-96 h-96 rounded-full bg-primary-400 blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-80 h-80 rounded-full bg-primary-300 blur-3xl" />
      </div>
      <div className="relative w-full px-4 md:px-6 lg:px-10 text-center">
        <div className="max-w-2xl mx-auto">
          <span className="text-primary-400 text-xs uppercase tracking-widest mb-3 block">Solicite Agora</span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white uppercase leading-tight mb-4">
            Orçamento Sem Compromisso
          </h2>
          <p className="text-foreground-400 text-sm md:text-base leading-relaxed mb-8">
            Nossa equipe técnica está pronta para indicar o equipamento ideal para seu projeto de impermeabilização. Atendemos todo o Brasil com suporte pós-venda local.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <a
              href={whatsappUrl}
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold px-8 py-4 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap text-sm uppercase tracking-wide"
            >
              <i className="ri-whatsapp-line text-lg" />
              Solicitar Orçamento
            </a>
            <a
              href={whatsappUrl}
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/30 text-white font-bold px-8 py-4 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap text-sm uppercase tracking-wide"
            >
              <i className="ri-customer-service-2-line" />
              Falar com Especialista
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}